import React from 'react';
import { HorizontalBarChartProps, ThemeConfig, PresetTheme } from '../types';
import { BarChart } from './BarChart';

export interface HorizontalBarChartComponentProps extends HorizontalBarChartProps {
  /** Preset theme name */
  theme?: PresetTheme;
  /** Custom theme configuration */
  themeConfig?: ThemeConfig;
}

/**
 * HorizontalBarChart Component
 * 
 * A horizontal bar chart optimized for comparing values across categories.
 * This is a convenience wrapper around BarChart with orientation="horizontal".
 * 
 * Perfect for:
 * - Comparing quantities across categories
 * - Displaying rankings or leaderboards
 * - Showing data with long category names
 * 
 * @example
 * ```tsx
 * <HorizontalBarChart
 *   labels={['Product A', 'Product B', 'Product C']}
 *   datasets={[
 *     { label: 'Sales', data: [150, 200, 180] }
 *   ]}
 *   theme="ocean"
 * />
 * ```
 */
export const HorizontalBarChart: React.FC<HorizontalBarChartComponentProps> = (props) => {
  return <BarChart {...props} orientation="horizontal" />;
};

export default HorizontalBarChart;
